/**
 * "Gövde Stok Yönetimi" sekmesi — rapordaki üçüncü sayfa.
 *
 * Sayfa süzgeci `govde_and_govde_on = "Gövde"` (api.js → `#govde`). Üstte
 * tanım bazında stok tablosu, altında saate göre gövde üretimi (sütun) ve
 * toplam stok (sağ eksende çizgi). Slicer'lar: Malzeme, Renk, U / Single.
 */
import { PROD_PATH } from "../api";
import { AMBER, WHITE } from "../theme";
import {
  BREAKPOINTS,
  slicer,
  tabloKarti,
  temizle,
  tvSecici,
  yiginYerlesim,
  zamanEkseni,
} from "./ortak";

export const GOVDE_STOK_ROWS = 24;

const LAYOUTS = yiginYerlesim([
  ["temizle", 2],
  ["f-malzeme", 6],
  ["f-renk", 3],
  ["f-us", 3],
  ["stok-tablosu", 12],
  ["uretim-stok", 9],
]);

export function buildGovdeStokConfig(rowPx, gap, refreshKey = 0, tvMode = false) {
  const V = tvSecici(tvMode);
  const GOVDE = { url: `${PROD_PATH}?_t=${refreshKey}#govde` };

  return {
    layout: { columns: 24, rowHeight: rowPx, gap, breakpoints: BREAKPOINTS },

    filters: [
      // Sol sütundaki logo kaldırıldı; boşalan 2 satırı Malzeme listesi aldı.
      temizle({ x: 0, y: 0, w: 3, h: 2 }, LAYOUTS),
      slicer("f-malzeme", "product", "Malzeme", { x: 0, y: 2, w: 3, h: 11 }, LAYOUTS, {
        selectAll: true,
      }),
      slicer("f-renk", "color", "Renk", { x: 0, y: 13, w: 3, h: 5 }, LAYOUTS),
      slicer("f-us", "u_single", "U / Single", { x: 0, y: 18, w: 3, h: 6 }, LAYOUTS),
    ],

    tiles: [
      tabloKarti(
        "stok-tablosu",
        null,
        GOVDE,
        [
          // Rapor tanıma göre grupluyor; aynı tanımı paylaşan satırların ID ve
          // malzeme kodları yan yana yazılır (raporda toplamları basılıyordu).
          { key: "id", label: "ID", agg: "join", wrap: true },
          { key: "order_nr", label: "Order Number", align: "center" },
          { key: "tarih", label: "Tarih" },
          { key: "saat", label: "Saat", align: "center" },
          { key: "product", label: "Malzeme", agg: "join", align: "center", wrap: true },
          { key: "tanim", label: "Tanım", align: "center" },
          { key: "inventory", label: "Toplam Stok", agg: "sum", align: "center", format: "int" },
        ],
        { x: 3, y: 0, w: 21, h: 13 },
        LAYOUTS,
        V,
        {
          groupBy: ["tarih", "saat", "tanim", "order_nr"],
          cellStyle: { size: V(16, 13) },
          headerStyle: { size: V(18, 15) },
        }
      ),

      {
        id: "uretim-stok",
        source: GOVDE,
        layout: { x: 3, y: 13, w: 21, h: 11 },
        layouts: LAYOUTS["uretim-stok"],
        chart: {
          type: "combo",
          title: "Saate göre Gövde Üretim ve Stok Seviyeleri",
          dimensions: ["zaman", "tarih"],
          measures: [
            { key: "production", label: "Üretim", type: "bar", color: AMBER },
            {
              key: "inventory",
              label: "Toplam Stok",
              type: "line",
              color: WHITE,
              axis: "right",
            },
          ],
          options: {
            ...zamanEkseni(V),
            className: "pano-uretim-stok",
            y2AxisWidth: V(52, 40),
            // Rapordaki "Araç ipuçları: Sipariş No" (periyodun en küçüğü;
            // periyotta tek sipariş var).
            tooltipFields: [{ key: "order_nr", label: "Sipariş No" }],
          },
        },
      },
    ],
  };
}
